import axios from "axios";

const API_URL = `${import.meta.env.VITE_API_URL}/cart`;

export interface CartProductPopulated {
  _id: string;
  name: string;
  colorName: string;
  colorCode: string;
  bunch: number;
  image: string;
}

export interface CartVariantPopulated {
  _id: string;
  s01: string;
  s02: string;
  s03: string;
  farm: string;
  country: string;
  stock: number;
  price: number;
  isPrivate: boolean;
  extra: { productName: string; colorName: string };
}

export interface CartCategoryPopulated {
  _id: string;
  name: string;
}

export interface CartBranchPopulated {
  _id: string;
  name: string;
}

export interface CartItemResponse {
  _id: string;
  variant: CartVariantPopulated;
  product: CartProductPopulated;
  category: CartCategoryPopulated;
  branch: CartBranchPopulated;
  quantity: number;
  reservedStock: number;
  price: number;
  addedAt: string;
}

export interface CartResponse {
  _id?: string;
  items: CartItemResponse[];
  branch?: CartBranchPopulated;
  itemCount: number;
  totalPrice: number;
  expiresAt: string | null;
  cartExpiryMinutes?: number;
  message?: string;
}

export interface AddToCartPayload {
  variantId: string;
  quantity: number;
}

export interface UpdateCartItemPayload {
  variantId: string;
  quantity: number;
}

export interface CheckoutPayload {
  deliveryDate: Date;
  deliveryTime: string;
  address: string;
  orderNotes?: string;
  shippingCost?: number;
}

export interface CheckoutResponse {
  order: { _id: string; orderNumber: string };
  message: string;
}

export const fetchCart = async (): Promise<CartResponse> => {
  const { data } = await axios.get(API_URL);
  return data;
};

export const addToCart = async (payload: AddToCartPayload): Promise<CartResponse> => {
  const { data } = await axios.post(`${API_URL}/items`, payload);
  return data;
};

export const updateCartItemQuantity = async ({
  variantId,
  quantity,
}: UpdateCartItemPayload): Promise<CartResponse> => {
  const { data } = await axios.put(`${API_URL}/items/${variantId}`, { quantity });
  return data;
};

export const removeCartItem = async (variantId: string): Promise<CartResponse> => {
  const { data } = await axios.delete(`${API_URL}/items/${variantId}`);
  return data;
};

export const clearCart = async (): Promise<CartResponse> => {
  const { data } = await axios.delete(API_URL);
  return data;
};

export const checkoutCart = async (payload: CheckoutPayload): Promise<CheckoutResponse> => {
  const { data } = await axios.post(`${API_URL}/checkout`, payload);
  return data;
};
